/* eslint-disable object-shorthand */
import React from "react";
import { createDfpAdComponent } from "@quintype/components";
import get from "lodash/get";

const ViewPortSizeMappingBanner970x90and728x90 = [
  { viewport: [970, 0], sizes: [[970, 90]] },
  { viewport: [728, 0], sizes: [[728, 90]] },
];

const ViewPortSizeMappingBanner300x600 = [
  { viewport: [300, 0], sizes: [[300, 600]] },
  { viewport: [160, 0], sizes: [[160, 600]] },
  { viewport: [120, 0], sizes: [[120, 600]] },
];

const getStandard300x250Ad = (id) => ({
  adUnit: id,
  sizes: [[300, 250]],
});

const getStandard728x90Ad = (id) => ({
  adUnit: id,
  sizes: [[728, 90]],
});

const get970x90ResponsiveAd = (id) => ({
  adUnit: id,
  sizes: [
    [728, 90],
    [970, 90],
  ],
  viewPortSizeMapping: ViewPortSizeMappingBanner970x90and728x90,
});

const get320x50stickyAd = (id) => ({
  adUnit: id,
  sizes: [[320, 50]],
});

export const CONFIG = {
  homeTopAd: get970x90ResponsiveAd("TQ20_HP_TOP_970x90"),
  homeAndSecTopMobile: {
    adUnit: "TQ20_HnS_Top_LB",
    sizes: [[320, 100]],
  },
  homePrem1: getStandard300x250Ad("TQ20_HP_Prem_300x250"),
  homePrem2: getStandard300x250Ad("TQ20_HP_TOP_300x250"),
  homeATF: getStandard300x250Ad("TQ20_HP_ATF_300x250"),
  homeBTF: getStandard300x250Ad("TQ20_HP_BTF_300x250"),
  home300x600: {
    adUnit: "TQ20_HP_ATF_300x600",
    sizes: [
      [120, 600],
      [160, 600],
      [300, 600],
    ],
    viewPortSizeMapping: ViewPortSizeMappingBanner300x600,
  },
  homeAndsecSticky: get320x50stickyAd("TQ20_HnS_Sticky_320x50"),
  secTopAd: get970x90ResponsiveAd("TQ20_Sec_TOP_970x90"),
  secContentDesktop: getStandard728x90Ad("TQ20_Sec_ATF_728x90"),
  secPrem1: getStandard300x250Ad("TQ20_SEC_Prem_300x250"),
  secPrem2: getStandard300x250Ad("TQ20_SEC_TOP_300x250"),
  secATF: getStandard300x250Ad("TQ20_SEC_ATF_300x250"),
  secBTF: getStandard300x250Ad("TQ20_SEC_BTF_300x250"),
  storyTopAd: get970x90ResponsiveAd("TQ20_ROS_TOP_970x90"),
  storyContentDesktop: getStandard728x90Ad("TQ20_ROS_ATF_728x90"),
  storyPrem1: getStandard300x250Ad("TQ20_ROS_Prem_300x250"),
  storyPrem2: getStandard300x250Ad("TQ20_ROS_TOP_300x250"),
  storyATF: getStandard300x250Ad("TQ20_ROS_ATF_300x250"),
  storyBTF: getStandard300x250Ad("TQ20_ROS_BTF_300x250"),
  storyBottomSticky: get320x50stickyAd("TQ20_ROS_Sticky_320x50"),
  ampPrem1: getStandard300x250Ad("TQ20_AMP_TOP_300x250"),
  ampPrem2: getStandard300x250Ad("TQ20_AMP_ATF_300x250"),
  ampATF: getStandard300x250Ad("TQ20_AMP_BTF_300x250"),
  ampBottomSticky: get320x50stickyAd("TQ20_AMP_Sticky_320x50"),
};

const DfpAdContent = createDfpAdComponent({
  defaultNetworkID: "52868882",
  config: CONFIG,
  targeting: function (state, props) {
    const params = {
      environment: get(state, ["qt", "config", ["publisher-attributes"], "env"]),
      pageType: get(state, ["qt", "pageType"]),
      publisherName: get(state, ["qt", "config", "publisher-name"]),
      publisherId: get(state, ["qt", "config", "publisher-id"]) || 1,
    };

    if (get(state, ["qt", "pageType"]) === "section-page") {
      params.section = get(state, ["qt", "data", "collection", "slug"], "");
      params.sectionName = get(state, ["qt", "data", "collection", "slug"], "");
    }

    if (get(state, ["qt", "pageType"]) === "story-page") {
      params.Contextual_Article = get(props, ["story", "seo", "meta-keywords"], []);
      params.sectionName = get(props, ["story", "sections", "0", "name"], "");
    }

    if (
      get(state, ["qt", "pageType"]) === "story-page" &&
      get(state, ["qt", "data", "story", "metadata", "sponsored-by"])
    ) {
      params.sponsor = get(state, ["qt", "data", "story", "metadata", "sponsored-by"]);
      return params.sponsor;
    }

    return params;
  },
});

const DfpAd = (props) => {
  return (
    <div>
      <DfpAdContent {...props} />
    </div>
  );
};

export default DfpAd;
